import {
  Grid,
  Paper,
  Typography,
  Box,
} from "@mui/material";

import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import ParkIcon from "@mui/icons-material/Park";
import SearchIcon from "@mui/icons-material/Search";

function StatsCards({ plants = [], filteredPlants = [] }) {

  // Automatically calculate unique plant families
  const familyCount = new Set(
    plants
      .map((plant) =>
        (
          plant.family ||
          plant.botanical_profile?.family ||
          ""
        )
          .trim()
          .toLowerCase()
      )
      .filter(Boolean)
  ).size;

  const stats = [
    {
      title: "Total Plants",
      value: plants.length,
      icon: <LocalFloristIcon sx={{ fontSize: 34 }} />,
      color: "#2E7D32",
      bg: "#E8F5E9",
    },
    {
      title: "Plant Families",
      value: familyCount,
      icon: <ParkIcon sx={{ fontSize: 34 }} />,
      color: "#1565C0",
      bg: "#E3F2FD",
    },
    {
      title: "Search Results",
      value: filteredPlants.length,
      icon: <SearchIcon sx={{ fontSize: 34 }} />,
      color: "#EF6C00",
      bg: "#FFF3E0",
    },
  ];

  return (
    <Grid container spacing={4} justifyContent="center" sx={{ mb: 5 }}>
      {stats.map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item.title}>
          <Paper
            elevation={0}
            sx={{
              height: "100%",
              minHeight: 150,
              borderRadius: 5,
              p: 4,
              border: "1px solid #E4EFE7",
              background: "#fff",
              transition: ".3s",
              boxShadow: "0 8px 25px rgba(0,0,0,.06)",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 18px 40px rgba(0,0,0,.12)",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "#888",
                    fontSize: 14,
                    fontWeight: 600,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    fontSize: 42,
                    fontWeight: 800,
                    color: "#0B3C5D",
                    lineHeight: 1,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  bgcolor: item.bg,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: item.color,
                }}
              >
                {item.icon}
              </Box>
            </Box>

            <Box
              sx={{
                mt: 3,
                height: 5,
                borderRadius: 10,
                bgcolor: item.bg,
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  bgcolor: item.color,
                }}
              />
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

export default StatsCards;